import { HttpClient } from "../httpClient";

const httpClient = new HttpClient();

const handleRegistration = (data: any) => {
    return httpClient.post(`Login/registry/account`, data);
}

const accountVerify = (verifyData: any) => {
    return httpClient.post(`Login/account/open`, verifyData);
}

const taxVerify = (tax: any) => {
    return httpClient.get(`Login/company-tax-format?tax=${tax}`);
}


const registratoionService = {
    handleRegistration,
    accountVerify,
    taxVerify,
};

export default registratoionService;